import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { HttpUtils } from '../../../common/http/http-utils';
import 'rxjs/add/observable/forkJoin';
import { ClientUtilities } from './utils/client-utils';
import { HttpClient } from '@angular/common/http';

export enum AlertilteredCategories {
    INFO = 'INFO',
    WARNING = 'WARNING',
    CRITICAL = 'CRITICAL'
}

@Injectable()
export class AlertsService {
    public allVCs: any = [];
    public apiBaseUrl;
    private getHCMApiPath = '/hybridity/api/metainfo/context/hcsp-dashboard';
    private getAlertsApiPath = '/hybridity/api/alerts?action=query';
    private acknowledgeAlertURL: string = '/hybridity/api/alerts/<alertId>/acknowledge';
    private deleteAlertURL: string = '/hybridity/api/alerts/<alertId>'

    constructor(public http: HttpClient) {
        const path = (window.location.pathname.match(/(.*)(\/alerts-ui)(\/.*|$)/) || [])[1];
        this.apiBaseUrl = (!!path && !!ClientUtilities.runningInPluginUI()) ? path + '/hcx-ui/rest' : '';
    }
    public getAllVCs() {
        return this.http.get(HttpUtils.getBaseUrl() + this.apiBaseUrl + this.getHCMApiPath)
            .map((res: any) => this.extractData(res));
    }

    public getAlerts(vcGuid: string) {
        const param = '&vcGuid=' + vcGuid;
        const url = HttpUtils.getBaseUrl() + this.apiBaseUrl + this.getAlertsApiPath + param;
        return this.http.post(url, {})
            ;
    }

    public acknowledgeAlert(alertId: string, vcGuid: string) {
        const param = '?vcGuid=' + vcGuid;
        const URL = HttpUtils.getBaseUrl() + this.apiBaseUrl + this.acknowledgeAlertURL.replace('<alertId>', alertId) + param;
        return this.http.post(URL, {});
    }

    public deleteAlert(alertId: string, vcGuid: string) {
        const param = '?vcGuid=' + vcGuid;
        const URL = HttpUtils.getBaseUrl() + this.apiBaseUrl + this.deleteAlertURL.replace('<alertId>', alertId) + param;
        return this.http.delete(URL, {});
    }

    private extractData(res: any) {
        if ( !this.allVCs.length ) {
            const body = res;
            if (!!body && !!body.data && !!body.data.localEndpoints) {
                body.data.localEndpoints = body.data.localEndpoints.filter( (endPoint) => endPoint.resourceType === 'VC');
                body.data.localEndpoints.forEach( (vc) => {
                    if(!vc.hasOwnProperty("errors")){
                        if (!!vc && !!vc.hcsp.serverAddress) {
                            delete vc['hcsp'];
                            vc['hostName'] = {'host': vc.resourceName || vc.name};
                            vc['serverGuid'] = vc.resourceId;
                            vc['serverName'] = vc.resourceName;
                            this.allVCs.push(vc);
                        }
                    }
                });
            }
        }
        return this.allVCs;
    }
}



// WEBPACK FOOTER //
// ./src/alerts/src/alerts-ui/alerts.service.ts